
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#339299","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","clip-path":"url(#clip0_5098_29904)"}},[_c('path',{attrs:{"d":"M13.442 12.335a2.023 2.023 0 01-1.612 0L2.06 7.809a.96.96 0 010-1.714l9.771-4.56a2.023 2.023 0 011.612 0l9.771 4.525a.96.96 0 010 1.715l-9.771 4.56zM23.778 13.106L13.32 17.923a1.714 1.714 0 01-1.423 0L1.492 13.106M23.778 18.677L13.32 23.494a1.714 1.714 0 01-1.423 0L1.492 18.677"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_5098_29904"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.633 .506)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    